import React, { Component } from 'react';
import i from '../imports';
import Session from '../services/session'
import Collapse from '@material-ui/core/Collapse';


const StyleText = {
    // paddingTop: "2px",
     marginTop: "-2px",
    // marginBottom: "2px",
    textAlign: "justify",
}

const StyleTitle = {
    fontSize: 24,
    fontWeight: "bold",
}


const StyleLink = {
    fontSize: 20,
    color: "#FF5563",
    cursor: "pointer"
}

const StyleImage = {
    width: '360px',
    height:'270px', 
 //   border: '3px solid #808080',
    marginRight: '26px',
}

const showMoreFadeStyle = {
    position: "absolute",
    bottom: -28,
    height: 56,
    marginBottom: 28,
    background: "linear-gradient(to top, white 50%, transparent)",
    width: "100%",
    marginLeft: 386,
    textAlign: "center",
    paddingRight: 386,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center"
    // marginTop: -30
}

const showMoreFadeMobileStyle = Object.assign({}, showMoreFadeStyle, {paddingRight: 0, marginLeft: 0});

const showMoreStyle = {
    width: "100%",
    background: "white"
}

class ImageWithDescription extends Component {

    state = {
        collapsed: true,
    };

    safeSubstring = (str, indexStart, indexEnd) =>{
        if(str.length < indexEnd)
            return str;

        let rawSubstring = str.substring(indexStart, indexEnd);
        if(rawSubstring.indexOf(' ') != rawSubstring.length - 1){
            return `${str.substring(indexStart, rawSubstring.lastIndexOf(' '))}... `;
        }
        return `${rawSubstring}... `;
    }

    render() {
        const { collapsed } = this.state;
        let maxSymbolsDesktop = (Session.language === 'ru' ? 440 : 500);
        let maxSymbolsMobile = 380;

        return (
            <i.PureGridProvider>
                <i.Container>
                    <i.OnAtLeastPhablet>
                        <i.Row style={{marginTop: "10px"}}>
                            <i.Col md={12} align="left" >
                                <Collapse in={!collapsed} collapsedHeight="270px">
                                    <div style={{float : "left"}}>
                                        <img src={this.props.pic} style={StyleImage} />
                                    </div>
                                    <div style={StyleTitle}>{this.props.title}</div>                                  
                                    <div className="content-text" style={StyleText}>
                                        {i.markdown(this.props.text)}
                                        {this.state.collapsed &&
                                        <div style={showMoreFadeStyle}>
                                            <span className="content-expand-link" style={showMoreStyle} onClick={() => {this.setState({ collapsed: !collapsed })}}>
                                                {Session.model.common.words.expand}
                                            </span>
                                        </div>}
                                    </div>
                                    {!this.state.collapsed && 
                                        <div style={{textAlign : "center"}}>
                                            <span className="content-expand-link" onClick={() => {this.setState({ collapsed: !collapsed })}}>{Session.model.common.words.collapse}</span>
                                        </div>
                                    } 
                                </Collapse>
                            </i.Col>
                        </i.Row>
                    </i.OnAtLeastPhablet>
                    <i.OnMobile>
                        <i.Row style={{marginTop: "10px"}}>
                            <i.Col md={12} align="center" >
                                <div style={StyleTitle}>{this.props.title}</div>
                            </i.Col>
                        </i.Row>
                        <i.Row >
                            <i.Col md={12} align="center" >
                                <div>
                                    <img src={this.props.pic} style={{...StyleImage, width:'100%', height:'auto'}} />
                                </div>
                            </i.Col>
                            <i.Col>
                                <Collapse in={!collapsed} collapsedHeight="160px">
                                <div className="content-text" style={StyleText}>
                                    {i.markdown(this.props.text)}
                                </div>
                                    {this.state.collapsed &&
                                    <div style={showMoreFadeMobileStyle}>
                                        <span className="content-expand-link" style={showMoreStyle} onClick={() => {this.setState({ collapsed: !collapsed })}}>
                                            {Session.model.common.words.expand}
                                        </span>
                                    </div> }
                                {!this.state.collapsed && 
                                    <div style={{textAlign : "center"}}>
                                        <span className="content-expand-link" onClick={() => {this.setState({ collapsed: !collapsed })}}>{Session.model.common.words.collapse}</span>
                                    </div>
                                } 
                                </Collapse>
                            </i.Col>
                        </i.Row>
                    </i.OnMobile>
                </i.Container>
            </i.PureGridProvider>
        );
    }
}

export default ImageWithDescription;